'use client';

import { useEffect, useRef } from 'react';
import { trackViewItem, TrackViewItemParams } from '@/features/gtm/shared/helper/track-view-item';

export const TrackViewItem = ({ params }: { params: TrackViewItemParams }) => {
  const lastTrackedItemIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const newItemId = params.itemId;
    if (!newItemId) return;
    if (lastTrackedItemIdRef.current === newItemId) return;

    lastTrackedItemIdRef.current = newItemId;

    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#view_item
    trackViewItem(params);
  }, [params]);

  return null;
};
